module.exports = __webpack_public_path__ + "static/media/icon-youtube-black.2bd1dd4e.svg";